module.exports = __webpack_public_path__ + "img/baby-stroller.81b6d74d.svg";